export const GooglePayIcon = ({
  strokeColor = "var(--color-icon-obscure)",
  ...props
}: any) => (
  <svg width="60" height="60" viewBox="0 0 60 60" fill="none">
    <path
      d="M30.5 14.675C30.325 14.675 30.15 14.675 30 14.7V5.02499C30.175 4.99999 30.325 5 30.5 5C36.15 5 41 6.725 44.975 9.65C46.225 10.55 46.325 12.375 45.225 13.45L41.75 16.85C40.9 17.675 39.6 17.825 38.625 17.15C36.75 15.85 34.075 14.675 30.5 14.675Z"
      fill={strokeColor}
    />
    <path
      d="M54.5 30.5492C54.5 38.1742 51.775 44.5742 47.05 48.9492C42.925 52.7742 37.25 54.9992 30.5 54.9992C30.325 54.9992 30.175 54.9993 30 54.9743V45.2992C30.175 45.3242 30.325 45.3242 30.5 45.3242C34.225 45.3242 37.05 44.2992 39.175 42.8242C42.5 40.4992 44 37.0242 44.275 34.7242H33C31.625 34.7242 30.5 33.5992 30.5 32.2242V27.9492C30.5 26.5742 31.625 25.4492 33 25.4492H51.875C53.15 25.4492 54.225 26.3993 54.35 27.6743C54.45 28.5493 54.5 29.4742 54.5 30.5492Z"
      fill={strokeColor}
    />
    <path
      opacity="0.4"
      d="M16.25 25.0504C15.75 26.6004 15.45 28.2754 15.45 30.0004C15.45 31.7254 15.75 33.3754 16.275 34.9504C18.225 40.8254 23.625 45.1004 30 45.3004V54.9754C20.45 54.8004 12.225 49.2504 8.2 41.2254H8.175C6.475 37.8254 5.5 34.0254 5.5 30.0004C5.5 25.9754 6.475 22.1754 8.175 18.7754C12.2 10.7504 20.425 5.20039 30 5.02539V14.7004C24.1 14.8754 19.075 18.5254 16.775 23.7004C16.575 24.1504 16.4 24.6004 16.25 25.0504Z"
      fill={strokeColor}
    />
  </svg>
);
